// extracted by mini-css-extract-plugin
export default {"PostsGrid":"PostsGrid_PostsGrid__w34go","PostsGrid__Grid":"PostsGrid_PostsGrid__Grid__LHSxK","PostsGrid__Ad":"PostsGrid_PostsGrid__Ad__-q6pZ"};